import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const KategoriSwitcher = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Set default ke FOODS
  const [isFood, setIsFood] = useState(true); 

  // Ketika URL berubah, cek apakah path dimulai dengan /menu atau /drink
  useEffect(() => {
    setIsFood(location.pathname.startsWith('/menu')); // Kalau path /menu, set isFood true (FOODS)
  }, [location.pathname]);

  return (
    <div className="flex justify-center gap-6 mt-6">
      <button
        onClick={() => navigate('/menu')}
        className={`px-4 py-2 font-bold border-b-4 transition duration-300 ${
          isFood
            ? 'border-pink-600 text-pink-600' // FOODS aktif
            : 'border-transparent text-gray-600 hover:text-pink-600 hover:border-pink-600' // Hover DRINKS
        }`}
      >
        FOODS
      </button>
      <button
        onClick={() => navigate('/drink')}
        className={`px-4 py-2 font-bold border-b-4 transition duration-300 ${
          !isFood
            ? 'border-pink-600 text-pink-600' // DRINKS aktif
            : 'border-transparent text-gray-600 hover:text-pink-600 hover:border-pink-600' // Hover FOODS
        }`}
      >
        DRINKS
      </button>
    </div>
  );
};

export default KategoriSwitcher;
